import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import notification from "common/utils/notification"
import useNewDocumento from "features/Crear/hooks/useNewDocumento"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { EDITAR_FACTURA_RECURRENTE } from "routes/RoutePaths"
import {
  canAsociarDocumentosSelector,
  getDocumentoSelector,
  getFacturaRecurrenteSelector,
  getJoinedConceptos,
  hideAsociarBtnSelector,
} from "../../redux/selectors/newDocumentoSelectors"
import { getNewDocumentCurrency } from "../../redux/selectors/newDocumentoSettingsSelectors"
import {
  setShowAsociarDocumentosModal,
  setShowDocumentoCreadoModal,
  setShowDocumentoEditadoModal,
} from "../../redux/slices/newDocumentoSettingsSlice"
import { readyToCreateDocumentoSelector } from "../../redux/slices/newDocumentoSlice"

const DocumentoHeader = ({
  getPdf,
  onCreate,
  onUpdate,
  titleDocumento,
  isFacturaRecurrente,
  isEditViewFacturaRecurrente,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [creatingDocumento, setCreatingDocumento] = useState(false)
  const [pdfDownloading, setPdfDownloading] = useState(false)
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()
  const readyToCreateDocumento = useSelector(readyToCreateDocumentoSelector)
  const hideAsociarDocumento = useSelector(hideAsociarBtnSelector)
  const canAsociarDocumentos = useSelector(canAsociarDocumentosSelector)
  const documentoGeneral = useSelector(getDocumentoSelector)
  const facturaRecurrente = useSelector(getFacturaRecurrenteSelector)
  const conceptos = useSelector(getJoinedConceptos)
  const divisaSelected = useSelector(getNewDocumentCurrency)
  const { checkIfLibradoHasEmailSelected } = useNewDocumento()
  const documento = isFacturaRecurrente ? facturaRecurrente : documentoGeneral
  const isFacturaRecurrenteEditing = history.location.pathname.includes(
    EDITAR_FACTURA_RECURRENTE
  )
  const dispatch = useDispatch()
  const document = {
    ...documento,
    ...{ conceptos },
    ...{ divisa: divisaSelected },
  }
  const handlePrint = async () => {
    setPdfDownloading(true)
    try {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      const tax = taxes.find((tax) => tax.id === document?.retencionTipoId)
      await getPdf({
        ...document,
        // @ts-expect-error TS(2339): Property 'grupoImpuesto' does not exist on type 'n...
        impuestoRetenido: tax ? tax?.grupoImpuesto?.categoria : null,
        importe: document?.total,
        extra: taxes,
      })

      setPdfDownloading(false)
    } catch (e) {
      notification.errorServidor({
        body: `${t("crear.facturaRec.msg.generatePdfError")}`,
      })
      setPdfDownloading(false)
    }
  }

  const handleCreateNewDocumento = async () => {
    if (!checkIfLibradoHasEmailSelected()) {
      return
    }

    setCreatingDocumento(true)
    try {
      if (isEditViewFacturaRecurrente) {
        await onUpdate(document)
        if (isFacturaRecurrenteEditing) {
          const idFacturaRecurrente =
            history?.location?.pathname?.split("/")[
              history?.location?.pathname.split("/")?.length - 1
            ]
          history.push(
            `/documentos/facturas-recurrentes/${idFacturaRecurrente}`
          )
          return
        }
        // @ts-expect-error TS(2345): Argument of type...
        dispatch(setShowDocumentoEditadoModal(true))
      } else {
        await onCreate(document)
        // @ts-expect-error TS(2345): Argument of type...
        dispatch(setShowDocumentoCreadoModal(true))
      }
    } finally {
      setCreatingDocumento(false)
    }
  }

  return (
    <div className='mb-3 d-flex justify-content-end'>
      <div>
        <div className='d-flex align-items-center'>
          {!isFacturaRecurrente && (
            <>
              {!hideAsociarDocumento && (
                <CustomButton
                  // @ts-expect-error TS(2345): Argument of type...
                  onClick={() => dispatch(setShowAsociarDocumentosModal(true))}
                  className='raised'
                  label={`${t("newDoc.pedido.associateDocLabel")}`}
                  disabled={!canAsociarDocumentos}
                />
              )}
            </>
          )}

          <CustomButton
            onClick={handlePrint}
            className='mx-2 raised icon'
            disabled={!readyToCreateDocumento}
            loading={pdfDownloading}
          >
            {/* @ts-expect-error TS(2322): Type '"fa-light"' is not assignable to type 'IconP... */}
            <FontAwesomeIcon icon={["fa-light", "fa-file-pdf"]} />
          </CustomButton>

          <CustomButton
            loading={creatingDocumento}
            disabled={!readyToCreateDocumento}
            onClick={handleCreateNewDocumento}
            className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none'
          >
            {isFacturaRecurrente
              ? isEditViewFacturaRecurrente
                ? `${t("crear.facturaRec.editButton")}`
                : `${t("crear.facturaRec.saveButton")}`
              : `
              Emitir
           ${titleDocumento.toLowerCase()}`}
          </CustomButton>
        </div>
      </div>
    </div>
  )
}

export default DocumentoHeader
